import {
  inheritEndpointOptions,
  WatchlistStoreModuleComponentDependencies,
  WatchlistStoreModuleFactory,
} from "@fds/wm-typescript-poc-waap-stores-mdg2";
import { EgbWatchlistPositionAddStoreModuleFactory } from "@/overrides/EgbWatchlistPositionAddStoreModuleFactory";

export class EgbWatchlistStoreModuleFactory extends WatchlistStoreModuleFactory {
  public getDependencies(): WatchlistStoreModuleComponentDependencies {
    const dependencies = super.getDependencies();
    const factoryData = {
      mdg2Client: this.mdg2Client,
      logger: this.logger,
      store: this.store,
    };
    const endpointConfiguration = this.options?.endpointConfiguration;

    dependencies.watchlistPositionAdd =
      new EgbWatchlistPositionAddStoreModuleFactory({
        ...factoryData,
        options: inheritEndpointOptions(
          endpointConfiguration,
          this.options?.positionAdd
        ),
      });
    return dependencies;
  }
}
